'use client';

import { type FC } from 'react';
import { Button, ButtonGroup } from '@/_components';
import { PDFZoomProps } from './PDFZoom.types';
import styles from './PDFZoom.module.css';
import { getClasses } from '@/_utils/classnames';

export const PDFZoom: FC<PDFZoomProps> = ({
  zoom,
  onZoomIn,
  onZoomOut,
  onResetZoom,
  minZoom = 0.5,
  maxZoom = 3,
  isTransparent,
  isFixed,
}) => {
  return (
    <ButtonGroup
      isSameLine={true}
      className={getClasses(styles.PDFZoom, {
        [styles.PDFZoom__transparent]: isTransparent,
        [styles.PDFZoom__fixed]: isFixed,
      })}
      isSmallGroup={true}
    >
      <Button
        intent="white-fill"
        size="small"
        value="Decrease Zoom"
        isIconOnly={true}
        iconLeft="minus"
        onClick={onZoomOut}
        isDisabled={zoom <= minZoom}
      />
      <Button
        intent="white-fill"
        size="small"
        tooltip="Reset Zoom"
        withTooltip
        tooltipPlacement="bottom"
        className={styles.PDFZoom__middle}
        value={`${Math.round(zoom * 100)}%`}
        onClick={onResetZoom}
      />
      <Button
        intent="white-fill"
        size="small"
        value="Increase Zoom"
        iconLeft="plus"
        isIconOnly={true}
        onClick={onZoomIn}
        isDisabled={zoom >= maxZoom}
      />
    </ButtonGroup>
  );
};
